import loginedApi from "../apis";
import CryptoJS from "crypto-js";
var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;

let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}

// Action Types
export const CLINIC_MANAGEMENT_TYPES = {
  FETCH_CLINICS: 'FETCH_CLINICS',
  FETCH_CLINIC_DETAILS: 'FETCH_CLINIC_DETAILS',
  CREATE_CLINIC: 'CREATE_CLINIC',
  UPDATE_CLINIC: 'UPDATE_CLINIC',
  DELETE_CLINIC: 'DELETE_CLINIC',
  UPDATE_CLINIC_STATUS: 'UPDATE_CLINIC_STATUS',
  FETCH_ALL_DOCTORS: 'FETCH_ALL_DOCTORS',
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR'
};

// Fetch all clinics
export const fetchAllClinics = (offset = 0, limit = 10) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("getclinics", {
      token: hashcode.toString(),
      data: {
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform,
        offset: offset,
        limit: limit
      },
      requestType: 2016,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.FETCH_CLINICS,
        payload: res.data.data
      });
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to fetch clinics' 
    });
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Fetch clinic details by ID
export const fetchClinicDetails = (clinicId) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("getclinicdetails", {
      token: hashcode.toString(),
      data: {
        clinicId: clinicId,
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2017,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.FETCH_CLINIC_DETAILS,
        payload: res.data.data
      });
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to fetch clinic details' 
    });
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Create new clinic
export const createClinic = (clinicData) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("insertclinic", {
      token: hashcode.toString(),
      data: {
        clinicName: clinicData.clinicName,
        clinicUrl: clinicData.clinicUrl,
        homeUrl: clinicData.homeUrl,
        clinicLogo: clinicData.clinicLogo || "",
        email: clinicData.email,
        phoneNumber: clinicData.phoneNumber,
        address: clinicData.address,
        doctors: clinicData.doctors || [],
        themeColor: clinicData.themeColor,
        hospitalBanner: clinicData.hospitalBanner || "",
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2018,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.CREATE_CLINIC,
        payload: res.data.data
      });
      return { success: true, data: res.data.data };
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to create clinic' 
    });
    return { success: false, error: error.message };
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Update clinic
export const updateClinic = (clinicId, clinicData) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("updateclinic", {
      token: hashcode.toString(),
      data: {
        clinicId: clinicId,
        clinicName: clinicData.clinicName,
        clinicUrl: clinicData.clinicUrl,
        homeUrl: clinicData.homeUrl,
        clinicLogo: clinicData.clinicLogo || "",
        email: clinicData.email,
        phoneNumber: clinicData.phoneNumber,
        address: clinicData.address,
        doctors: clinicData.doctors || [],
        themeColor: clinicData.themeColor,
        hospitalBanner: clinicData.hospitalBanner || "",
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2019,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.UPDATE_CLINIC,
        payload: { clinicId, data: res.data.data }
      });
      return { success: true, data: res.data.data };
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to update clinic' 
    });
    return { success: false, error: error.message };
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Delete clinic
export const deleteClinic = (clinicId) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("deleteclinic", {
      token: hashcode.toString(),
      data: {
        clinicId: clinicId,
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2020,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.DELETE_CLINIC,
        payload: clinicId
      });
      return { success: true };
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to delete clinic' 
    });
    return { success: false, error: error.message };
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Update clinic status (Activate/Deactivate)
export const updateClinicStatus = (clinicId, status) => async (dispatch) => {
  try {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: true });
    
    let res = await loginedApi.post("updateclinicstatus", {
      token: hashcode.toString(),
      data: {
        clinicId: clinicId,
        status: status,
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2021,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.UPDATE_CLINIC_STATUS,
        payload: { clinicId, status }
      });
      return { success: true };
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to update clinic status' 
    });
    return { success: false, error: error.message };
  } finally {
    dispatch({ type: CLINIC_MANAGEMENT_TYPES.SET_LOADING, payload: false });
  }
};

// Fetch all doctors for selection
export const fetchAllDoctorsForSelection = () => async (dispatch) => {
  try {
    let res = await loginedApi.post("getalldoctors", {
      token: hashcode.toString(),
      data: {
        browserTimeZone: `GMT${formatTime}`,
        userAgent: userAgent,
        Browser: browser.name + " " + browser.version,
        appname: "C2MD Web",
        Os: platform
      },
      requestType: 2022,
    });

    if (res.status === 200) {
      dispatch({
        type: CLINIC_MANAGEMENT_TYPES.FETCH_ALL_DOCTORS,
        payload: res.data.data
      });
      return res.data.data;
    }
  } catch (error) {
    dispatch({ 
      type: CLINIC_MANAGEMENT_TYPES.SET_ERROR, 
      payload: error.message || 'Failed to fetch doctors' 
    });
  }
};

// Upload clinic logo
export const uploadClinicLogo = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('token', hashcode.toString());
    formData.append('requestType', '2023');
    formData.append('browserTimeZone', `GMT${formatTime}`);
    formData.append('userAgent', userAgent);
    formData.append('Browser', browser.name + " " + browser.version);
    formData.append('appname', 'C2MD Web');
    formData.append('Os', platform);

    let res = await loginedApi.post("uploadcliniclogo", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Upload hospital banner
export const uploadHospitalBanner = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('token', hashcode.toString());
    formData.append('requestType', '2024');
    formData.append('browserTimeZone', `GMT${formatTime}`);
    formData.append('userAgent', userAgent);
    formData.append('Browser', browser.name + " " + browser.version);
    formData.append('appname', 'C2MD Web');
    formData.append('Os', platform);

    let res = await loginedApi.post("uploadhospitalbanner", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (res.status === 200) {
      return { success: true, data: res.data.data };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};
